export class GoToDealsTabEvent {}
